//Library Imports
import { FC, useState, useEffect } from "react";
// import { Checkbox } from "antd";
import store, { RootState } from "store";
import { useSelector } from "react-redux";

//Local Imports
import useVisible from "modules/Analytics/Shared/useVisible";
import { ReactComponent as DownAngle } from "../../../assets/img/icons/DownAngle.svg";
import { ReactComponent as Sort } from "../../../assets/img/icons/Sort.svg";
import ButtonSmall from "./ButtonSmall";
import { IFiltersItem } from "modules/Content/MyAccounts/interface";
import { ACCOUNTS_NEWS, MY_ACCOUNTS } from "constants/actionTypes";
import { getAccountsNews, myAccountsSelectAllFilter } from "modules/Content/MyAccounts/actions";
import Checkbox from "./Checkbox";

//Style Imports
import styled from "styled-components";
import { Tooltip } from "antd";

type CategoryFilterProps = {
  disable: boolean;
};

const CategoryFilter: React.FC<CategoryFilterProps> = (props: CategoryFilterProps) => {
  const { disable } = props;
  const { ref, isVisible, setIsVisible } = useVisible(false);
  // const [selectAll, setSelectAll] = useState(false);
  const selectAll = useSelector((state: RootState) => state.myAccounts.selectAll);
  // const [filtersArr, setFiltersArr] = useState(Array<IFiltersItem>());
  const filters: IFiltersItem[] = useSelector((state: RootState) => state.accountsNews.filters);
  const loading: boolean = useSelector((state: RootState) => state.myAccounts.loading);
  const selectedFilters: number[] = useSelector((state: RootState) => state.myAccounts.selectedFilters);
  const previouslySelectedFilters: number[] = useSelector(
    (state: RootState) => state.myAccounts.previouslySelectedFilters
  );
  const [isApplyDisabled, setIsApplyDisabled] = useState(true);
  const selectedAccounts: number[] = useSelector((state: RootState) => state.myAccounts.selectedAccounts);

  const selectAllClickHandler = (isSelectAll: boolean) => {
    if (isSelectAll) {
      myAccountsSelectAllFilter(true);
      // setFiltersArr(filters);
      let ids: number[] = [];
      filters.map((item) => ids.push(item.filterId));
      store.dispatch({
        type: MY_ACCOUNTS.UPDATE_FILTERS_STATE,
        selectedFilters: ids,
        selectAll: isSelectAll,
      });
    } else {
      // setFiltersArr([]);
      myAccountsSelectAllFilter(false);
      store.dispatch({
        type: MY_ACCOUNTS.UPDATE_FILTERS_STATE,
        selectedFilters: [],
        selectAll: isSelectAll,
      });
    }
  };

  const populateSelectedFilter = (filterItem: IFiltersItem) => {
    let index = selectedFilters.findIndex((item) => item === filterItem.filterId);
    let filteredArray: any = [...selectedFilters];
    if (index > -1) {
      filteredArray.splice(index, 1);
      if (selectAll) {
        myAccountsSelectAllFilter(false);
      }
    } else {
      filteredArray.push(filterItem.filterId);
      if (!selectAll && filteredArray.length === filters.length) {
        myAccountsSelectAllFilter(true);
      }
    }
    store.dispatch({
      type: MY_ACCOUNTS.UPDATE_FILTERS_STATE,
      selectedFilters: filteredArray,
    });
  };

  const filterTags = () => {
    setIsVisible(false);
    store.dispatch({
      type: MY_ACCOUNTS.UPDATE_PREVIOUS_FILTERS_STATE,
    });
    store.dispatch({
      type: ACCOUNTS_NEWS.PAGE_RESET,
    });
    getAccountsNews(0, selectedAccounts, selectedFilters, selectAll);
  };

  useEffect(() => {
    if (selectedFilters.length === 0) {
      setIsApplyDisabled(true);
    } else if (selectedFilters.length !== previouslySelectedFilters.length) {
      setIsApplyDisabled(false);
    } else {
      let equalArrays = true;
      for (let st of selectedFilters) {
        if (!previouslySelectedFilters.includes(st)) {
          equalArrays = false;
        }
      }
      if (equalArrays) {
        setIsApplyDisabled(true);
      } else {
        setIsApplyDisabled(false);
      }
    }
  }, [selectedFilters, previouslySelectedFilters]);

  return (
    <Wrapper>
      <div
        className={`dropdown-selecter ${isVisible ? "active" : ""} ${loading || disable ? "disabled" : ""}`}
        onClick={() => {
          if (!isVisible) {
            setIsVisible(true);
          }
        }}
      >
        <div className={"label"}>
          <Sort style={{ height: 18, width: 18 }} />
          &nbsp;&nbsp;Filter
        </div>
        <div className="d-flex">
          <div className="seprator"></div>
          <div className="p-2">
            <DownAngle />
          </div>
        </div>
      </div>
      <div ref={ref} className={`dropdown-options ${isVisible ? "show" : ""}`}>
        {/* Toggle class "show" to show and hide dropdown */}
        <div className="dropdown-options-inner">
          <div id="MultiSelectCatId" className="dropdown-wrapper">
            <div className="header-of-category d-flex justify-content-between">
              <span>
                <Sort style={{ height: 20, width: 22 }} />
                Filter
              </span>
              <ButtonSmall value="Apply" onClick={filterTags} isDisabled={isApplyDisabled} />
            </div>
            {selectedFilters.length === 0 && (
              <span className={"select-least-one"}>Please Select One Filter at Least</span>
            )}
            <div className="dropdown-top-filters">
              <span className="d-flex justify-content-between select-text-style">
                <p className="grey">Content category alerts:</p>

                {selectAll === true || selectedFilters.length === filters.length ? (
                  <p
                    className="green pt-1"
                    onClick={() => selectAllClickHandler(false)}
                    id="deselect-all-list"
                    data-qa="qa-deselect-all"
                  >
                    deselect all
                  </p>
                ) : (
                  <p
                    className="green pt-1"
                    onClick={() => selectAllClickHandler(true)}
                    id="select-all-list"
                    data-qa="qa-select-all"
                  >
                    select all
                  </p>
                )}
              </span>
              <ul>
                {filters.map((item: IFiltersItem, index) => (
                  <li key={index}>
                    <label>
                      <Checkbox
                        onClick={() => populateSelectedFilter(item)}
                        checked={selectedFilters.includes(item.filterId) || selectAll === true}
                        onChange={() => { }}
                        data-id={item.filterName + item.filterId}
                      />
                      <Circle color={item.filterColor} />
                      <span className="filterName">
                        <Tooltip placement="top" title={item.filterName}>
                          {item.filterName}
                        </Tooltip></span>
                    </label>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default CategoryFilter;

const Circle = styled.div<{ color: string }>`
  width: 16px;
  height: 16px;
  background: ${(props) => props.color};
  border-radius: 50%;
  margin: 5px 8px 0px 8px !important;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    width: 10px;
    height: 10px;
  }
`;
const Wrapper = styled.div`
  position: relative;
  .disabled {
    pointer-events: none;
    opacity: 0.6;
  }
  .select-least-one {
    color: #ff0000 !important;
    text-align: center;
    font-weight: 500;
    font-family: Roboto;
    font-size: 16px;
    display: block;
    float: left;
    width: 100%;
    margin-bottom: 15px;
  }
  .filterName{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }
  .dropdown-selecter {
    border: 1px solid #dadada;
    min-width: 130px;
    background: #fff;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding-left: 10px;
    padding-right: 2px;
    height: 38px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      /* min-width: 200px; */
      border-radius: 6px;
      height: 30px;
    }
    &:focus,
    &:active,
    &.active {
      box-shadow: 0 0 0 0.1rem rgb(40 167 69 / 50%);
    }
    .label {
      color: #7e7e7e;
      font-size: 16px;
      font-weight: 500;
      font-family: "Roboto", sans-serif;
      flex-wrap: wrap;
      padding: 2px 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 200px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
      }
      img {
        margin-top: -3px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 15px;
        }
      }
    }
    .seprator {
      -webkit-align-self: stretch;
      -ms-flex-item-align: stretch;
      align-self: stretch;
      background-color: hsl(0, 0%, 80%);
      margin-bottom: 8px;
      margin-top: 8px;
      width: 1px;
      box-sizing: border-box;
      + .p-2 {
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          padding-top: 3px !important;
          padding-bottom: 3px !important;
        }
      }
    }
  }
  .dropdown-options {
    background: #fff;
    position: absolute;
    top: 40px;
    left: auto;
    right: 0px;
    z-index: 9;
    min-width: 100%;
    width: auto;
    border-radius: 8px;
    width: 385px;
    transition-duration: 0.5s;
    overflow: hidden;
    height: 0px;
    opacity: 0;
    box-shadow: 0px 5px 14px 0px rgb(0 0 0 / 28%);
    &.show {
      height: auto;
      opacity: 1;
    }
    .dropdown-options-inner {
      border: 1px solid #def6e6;
      box-shadow: 0 0 40px 0 rgb(0 0 0 / 28%);
      background: #fff;
      border-radius: 8px;
      float: left;
      width: 100%;
      .message-limit {
        float: left;
        width: 100%;
        padding: 15px;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        font-family: "Roboto", sans-serif;
        color: #ffa112;
        background: #ebf5ee;
      }
      .dropdown-header {
        background: #def6e6;
        color: #27ce0a;
        font-weight: 500;
        font-size: 16px;
        line-height: 40px;
        font-family: "Roboto", sans-serif;
        padding: 10px 16px 0 16px;
        border-radius: 8px 8px 0 0;
        float: left;
        width: 100%;
        svg {
          height: 12px;
          width: 16px;
          margin-right: 12px;
        }
        .sub-header {
          border: 1px solid #dadada;
          padding: 10px;
          background: #f7f7f7;
          float: left;
          margin: 10px -17px 0 -17px;
          width: calc(100% + 34px);
        }
      }
      .dropdown-wrapper {
        float: left;
        width: 100%;
        overflow: auto;
        @media all and (max-height: 690px) {
          max-height: 450px;
        }
        &::-webkit-scrollbar {
          width: 5px;
          height: 5px;
          border-radius: 5px;
        }
        /* Track */
        &::-webkit-scrollbar-track {
          background: #fff;
          margin-top: 10px;
          margin-bottom: 15px;
        }
        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: #001760;
        }
        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: #efefef;
        }
        .ant-checkbox:hover::after,
        .ant-checkbox-wrapper:hover .ant-checkbox::after {
          visibility: hidden;
        }
      }
      .header-of-category {
        padding: 12px 22px;
        background-color: #fff;
        align-items: center;
        span {
          color: #424b50;
          font-size: 28px;
          font-weight: 500;
          font-family: "Roboto Slab", serif;
          svg {
            margin-right: 6px;
            g {
              fill: #000000;
            }
          }
        }
        button {
          max-height: 40px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            max-height: 34px;
          }
        }
      }
      .dropdown-top-filters {
        padding: 16px 22px 16px 22px;
        float: left;
        width: 100%;
        background-color: #f8f8f8;
        .select-text-style {
          font-size: 14px;
          font-weight: 500;
          font-family: "Roboto", sans-serif;
          .grey-light {
            color: #7e7e7e;
            font-size: 16px;
          }
          .grey {
            color: #67696a;
            font-size: 18px;
          }
          .green {
            color: #1ec252;
            cursor: pointer;
          }
        }
        h4 {
          color: #424b50;
          font-size: 14px;
          font-weight: 500;
          font-family: "Roboto", sans-serif;
          margin: 0;
          line-height: 40px;
          width: 100%;
          float: left;
        }
        ul {
          width: 100%;
          float: left;
          display: block;
          padding: 0;
          margin: 10px 0 0 0;
          li {
            list-style-type: none;
            margin: 5px 0;
            width: 50%;
            display: block;
            float: left;
            label {
              font-family: "Roboto", sans-serif;
              color: #7e7e7e;
              font-size: 16px;
              font-weight: 500;
              cursor: pointer;
              display: block;
              padding: 0px 0;
              float: left;
              &:hover {
                color: #27ce0a;
              }
              .ant-checkbox-wrapper {
                display: inline-block;
                float: left;
                &::after {
                  display: none;
                }
              }
              > div {
                float: left;
                margin-top: 5px !important;
              }
            }
          }
        }
      }
      .dropdown-body {
        padding: 0 16px;
        width: 100%;
        float: left;
        ul {
          width: 100%;
          float: left;
          padding: 20px 20px 20px 0px;
          list-style-type: none;
          li {
            width: 100%;
            float: left;
            padding: 0;
            margin: 0;
            .label {
              font-family: "Roboto", sans-serif;
              color: #7e7e7e;
              font-size: 14px;
              font-weight: 500;
              cursor: pointer;
              display: block;
              padding: 5px 0;
              line-height: 30px;
              white-space: nowrap;
              text-overflow: ellipsis;
              word-break: keep-all;
              overflow: hidden;
              width: 165px;
              min-width: 165px;
              transition-duration: 0.5s;
            }
            .tick {
              opacity: 0;
              transition-duration: 0.5s;
              margin-right: 13px;
              float: left;
              svg {
                height: 12px;
                width: 16px;
                vertical-align: baseline;
              }
            }
            .current {
              color: #27ce0a;
              opacity: 1;
            }
          }
        }
      }
    }
  }
`;
